import React from "react"

import globalStyles from "../../../../App.module.scss";
import inputListing from './images/input.png'
import output from './images/output.png'
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

export default function FileOrganizer() {

    let data = `import shutil
import sys
from pathlib import Path

CATEGORIES = {
    "Images": {".jpg", ".jpeg", ".png", ".gif", ".webp", ".heic"},
    "Documents": {".pdf", ".doc", ".docx", ".txt", ".md", ".xlsx", ".csv"},
    "Archives": {".zip", ".tar", ".gz", ".rar", ".7z"},
    "Audio": {".mp3", ".wav", ".flac", ".m4a"},
    "Video": {".mp4", ".mov", ".avi", ".mkv"},
    "Installers": {".dmg", ".pkg", ".exe", ".msi"},
}


def category_for(extension):
    for category, extensions in CATEGORIES.items():
        if extension.lower() in extensions:
            return category
    return "Other"


def organize(directory):
    moved = 0
    for path in Path(directory).iterdir():
        if not path.is_file():
            continue
        category = category_for(path.suffix)
        target_dir = Path(directory) / category
        target_dir.mkdir(exist_ok=True)
        shutil.move(str(path), str(target_dir / path.name))
        moved += 1
    return moved


def main():
    directory = sys.argv[1] if len(sys.argv) > 1 else "."
    moved = organize(directory)
    print(f"Organized {moved} file(s) in {directory}")


if __name__ == "__main__":
    main()
`

    return (
        <div className={globalStyles.article}>
            <h1>Auto file organizer</h1>
            <p>Sorts every file directly inside a folder into subfolders by type — Images, Documents, Archives,
                Audio, Video, Installers, or Other. Point it at a messy Downloads folder and run it whenever it
                gets out of hand, or hook it up to a scheduled task/cron job.</p>
            <div style={{maxWidth: '800px'}}>
                <SyntaxHighlighter
                    children={data}
                    style={dracula}
                    PreTag="div"
                    language={'python'}
                />
            </div>

            <p>Before: a flat, messy folder.</p>
            <div style={{maxWidth: '800px'}}>
                <img src={inputListing} alt={""}/>
            </div>

            <p>After: running the script sorts everything into subfolders by type.</p>
            <div style={{maxWidth: '800px'}}>
                <img src={output} alt={""}/>
            </div>
        </div>
    )
}
